import type { TranslationKey } from "@qualtio-workhub/i18n";

const activityLabels: Record<string, TranslationKey> = {
  "issue.created": "issue.activity.created",
  "issue.updated": "issue.activity.updated",
  "issue.status_changed": "issue.activity.status",
  "issue.assigned": "issue.activity.owner",
  "issue.agent_assigned": "issue.activity.agent",
  "comment.created": "issue.activity.comment",
  "agent.run_started": "issue.activity.runStarted",
  "agent.run_updated": "issue.activity.runUpdated",
  "agent.waiting_for_human": "issue.activity.waiting",
  "agent.run_completed": "issue.activity.runCompleted",
  "agent.run_failed": "issue.activity.runFailed",
  "artifact.attached": "issue.activity.artifact",
  "github.pr_linked": "issue.activity.pr",
};

export function activityLabel(type: string, t: (key: TranslationKey) => string): string {
  const key = activityLabels[type];
  return key ? t(key) : type.replaceAll(/[._]/g, " ");
}
